import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {AfterViewInit, Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterLink} from '@angular/router';
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {ApiService} from "../../../_services/api.service";
import {Endpoints} from "../../../endpoints";
import {DialogService} from "../../../_modal/dialog.service";
import {environment} from "../../../../../environments/environment";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {ExploitationType, ExpoilataionDto} from "../../../_models/exploitation.dtos";
import {HandleErrorsService} from "../../../../services/handle-erros/handle.errors.service";
import {ExploitationService} from "../../../../services/exploitation-service/exploitation.service";
import {ClientsService} from "../../../../services/client-service/clients.service";
import {ClientDto, ShortClientDto} from "../../../_models/client.dtos";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {CookieService} from "ngx-cookie-service";
import * as L from "leaflet";
import {CoordonneesGps} from "../../../_models/coordonnees-gps";

@Component({
    selector: 'app-client-exploitation-list',
    standalone: true,
    providers: [ApiService, Endpoints, DialogService, HandleErrorsService, ExploitationService, ClientsService],
    imports: [DatePipe,
        MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
        MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput, MatDatepicker,
        MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect, NgForOf, MatCheckbox, FormsModule
    ],
    templateUrl: './clients-exploitation-list.component.html',
    styleUrl: './clients-exploitation-list.component.scss'
})
export class ClientsExploitationListComponent implements OnInit, AfterViewInit {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<any>;
    @ViewChild('viewModal') viewModal: TemplateRef<any>;
    exploitation? : ExpoilataionDto
    editForm: FormGroup;
    form: FormGroup;
    clientList: ClientDto[];
    dataSource = new MatTableDataSource<ExpoilataionDto>();
    searchValue = ''
    loadingTable: boolean = true;
    map: L.Map
    marker: L.Marker;
    coordonnes: CoordonneesGps = new CoordonneesGps()
    icon = L.icon({
        iconUrl: 'assets/images/mapIcons/marker-icon.png',
        shadowUrl: 'assets/images/mapIcons/marker-shadow.png',
        iconSize: [25, 41], // size of the icon
        shadowSize: [41, 41], // size of the shadow
        iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
        shadowAnchor: [12, 41],  // the same for the shadow
        popupAnchor: [1, -34] // point from which the popup should open relative to the iconAnchor
    });
    mapId: string = ''
    columnLabels: Record<string, string> = {
        name: 'Nom',
        typeId: 'Type',
        client: 'Client',
        details: 'Détails',
        flag: 'Indicateur',
        creationDate: 'Date de création',
        updateDate: 'Dernière MAJ',
        createdBy: 'Créé par',
    };
    displayedColumns: string[] = ['name', 'typeId', 'client', 'details', 'flag', 'creationDate', 'updateDate', 'createdBy'];
    columns: string[] = [...this.displayedColumns];
    exploitationTypes:ExploitationType[] = []
    constructor(
        private cookieService: CookieService,
        private exploitationService: ExploitationService,
        private handleErrors: HandleErrorsService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private clientService: ClientsService,
        private overlayContainer: OverlayContainer) {
        this.initializeEditForm();
        this.initializeCreateForm()
        this.fetchClientList();
    }

    ngOnInit(): void {
        this.fetchExploitationList()
        this.getColsCookie()
        this.exploitationService.getAllTypes().subscribe(data => {
          this.exploitationTypes = data;
});

    }

    fetchExploitationList() { 
        this.exploitationService.fetchExploitationList().subscribe({
            next: value => {
                console.log('Data from backend:', value);  // Afficher l'objet du backend dans la console
                this.dataSource.data = value;
                this.loadingTable = false;
            },
            error: err => {
                console.error('Error fetching exploitation list:', err);  // Afficher l'erreur s'il y en a
            }
        });
    }
    

    ngAfterViewInit() {
        this.initializePaginatorAndSort();
    }

    initializePaginatorAndSort() {
        this.overlayContainer.getContainerElement().style.zIndex = '2000';
        this.dataSource.filter = this.searchValue
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'asc';
    }

    initializeEditForm() {
        this.editForm = this.fb.group({
            id: ['', Validators.required],
            typeId: ['', Validators.required],
            name: ['', Validators.required],
            details: [''],
            flag: ['', Validators.required],
            lat: [''],
            lon: [''],
            creationDate: [''],
            clientId: ['', Validators.required],
            userId: ['', Validators.required]
        });
    }
    isEditable: boolean = true; // Par défaut, tu peux autoriser l'édition
    initializeCreateForm() {
        this.form = this.fb.group({
            name: ['', Validators.required],
            typeId: ['', Validators.required],
            details: [''],
            lat: ['',Validators.required],
            lon: ['',Validators.required],
            flag: [true, Validators.required],
            clientId: ['', Validators.required]
        });
    }

    onMapClick(event: any): void {
        const clickedLat = event.latLng.lat();  // Obtenir la latitude
        const clickedLon = event.latLng.lng();  // Obtenir la longitude
        
        this.form.patchValue({
            lat: clickedLat,
            lon: clickedLon
        });

        console.log(`Clic sur la carte - Latitude: ${clickedLat}, Longitude: ${clickedLon}`);
    }
    
    save(): void {
        console.log("Début de la sauvegarde...");
        
        if (this.form.valid) {
            console.log("✅ Formulaire valide !");
            
            // Vérifier les valeurs du formulaire
            console.log("Valeurs du formulaire :", this.form.value);
            
            const exploitation: ExpoilataionDto = this.form.value;
            exploitation.lat = this.coordonnes.latitude;  // Vérifie bien que c'est `latitude`
            exploitation.lon = this.coordonnes.longitude;
    
            // Vérifier l'objet avant l'envoi
            console.log("Objet exploitation préparé :", exploitation);
    
            this.exploitationService.save(exploitation).subscribe({
                next: response => {
                    console.log("Réponse reçue de l'API :", response);
    
                    if (response.status) {
                        console.log("✅ Sauvegarde réussie !");
                        this.dataSource.data = [...this.dataSource.data, response.data];
                        this.modalService.dismissAll();
                        this.dialogService.openSuceessAlert(response.message);
                    } else {
                        console.error("❌ Erreur côté serveur :", response.message);
                        this.dialogService.open(response.message, environment.error_message_type, 'danger', environment.error_icon).finally();
                    }
                },
                error: err => {
                    console.error("🚨 Erreur lors de l'appel API :", err);
                    this.handleErrors.catchError(err);

                }
            });
        } else {
          console.log('Formulaire invalide, vérifiez les champs');
          Object.keys(this.form.controls).forEach((controlName) => {
              const control = this.form.get(controlName);
              if (control && control.invalid) {
                  console.log(`Le champ ${controlName} est invalide. Erreurs:`, control.errors);
              }
          });
        }
    }    



    openEditModal(element: ExpoilataionDto) {
        console.log(element)
        this.editForm.patchValue(element);
        this.modalService.open(this.editModal, {ariaLabelledBy: 'modal-basic-title', size: 'xl'});
    
        this.mapId = 'edit-modal-map';
        this.coordonnes.latitude = element.lat;
        this.coordonnes.longitude = element.lon;
    
        // Attendre la fin de l'ouverture du modal avant d'initialiser la carte
        setTimeout(() => {
            this.initializeMap();
        }, 500); // Attendre 500ms avant d'initialiser la carte
    }
    

    fetchClientList() {
        this.clientService.loadClients().subscribe({
            next: response => {
                if (response.status) {
                    this.clientList = response.data;
                }
            },error : err => this.handleErrors.catchError(err)
        });
    }

    openModal(content: any) {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then(
            () => { // on modal close
                this.form.reset();
            },
            () => { // on modal dismissed
                this.form.reset();
            }
        );
    
        // Vérifier si la géolocalisation est disponible
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    // Récupérer les coordonnées de l'utilisateur
                    this.coordonnes.latitude = position.coords.latitude;
                    this.coordonnes.longitude = position.coords.longitude;
    
                    // Mettre à jour les champs du formulaire avec les coordonnées
                    this.form.patchValue({
                        lat: this.coordonnes.latitude, // latitude dans le formulaire
                        lon: this.coordonnes.longitude // longitude dans le formulaire
                    });
    
                    // Initialiser la carte avec les nouvelles coordonnées
                    this.mapId = 'map-for-new-modal';
                    this.initializeMap();
                },
                () => {
                    this.dialogService.openDangerAlert('Impossible d\'obtenir votre position');
                }
            );
        } else {
            this.dialogService.openDangerAlert('La géolocalisation n\'est pas prise en charge par votre navigateur');
        }
    }
    

    update() {
        if (this.editForm.valid) {
            let  dto : ExpoilataionDto = this.editForm.value
            dto.lat = this.coordonnes.longitude
            dto.lon = this.coordonnes.longitude
            this.exploitationService.update(dto).subscribe({
                next : response => {
                    if (response.status) {
                        let clientExploitation = response.data;
                        this.updateTableRow(clientExploitation);
                        this.modalService.dismissAll();
                        this.dialogService.openSuceessAlert(response.message);
                        this.initializePaginatorAndSort();
                    }else{
                        this.dialogService.open(response.message, environment.error_message_type, 'danger', environment.error_icon).finally();

                    }
                },error : err => this.handleErrors.catchError(err)
            });

        } else {
            this.dialogService.open('Veuillez vérifier votre saisie et soumettre à nouveau!', environment.error_message_type, 'danger', environment.error_icon).finally();
        }
    }

    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
            this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
        }
    }

    confirmDelete(element: any) {
        this.dialogService.open('Êtes-vous sûr de vouloir supprimer cette exploitation client ?', environment.warning_message_type, 'danger', environment.warning_icon, true)
            .then((result: any) => {
                if (result) {
                    this.deleteClient(element.id);
                }
            });
    }

    deleteClient(id: number) {
        this.exploitationService.delete(id).subscribe(
            {
                next : response => {
                    if (response.status) {
                        this.removeTableRow(id);
                        this.dialogService.open('Exploitation supprimée avec succès', environment.info_message_type, 'success', environment.info_icon).finally();
                        this.initializePaginatorAndSort()
                    }
                },error :err => this.handleErrors.catchError(err),
            }
        );
    }

    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter(item => item.id !== id);
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        this.searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource.filter =  this.searchValue;
    }

    openViewModal(element: ExpoilataionDto, viewModal: TemplateRef<any>) {
        this.exploitation = element
        this.modalService.open(viewModal, {animation : true , ariaLabelledBy: 'modal-basic-title', size: 'xl'});

        this.mapId = 'map-view-modal'
        this.coordonnes.latitude = this.exploitation.lat
        this.coordonnes.longitude = this.exploitation.lon
        this.initializeMap()
    }

    handleIsAllColsSelected(event: MatCheckboxChange) {
        if (event.checked) {
            this.displayedColumns = [...this.columns]
        } else {
            this.displayedColumns = []
        }
        this.setColsCookie()
    }

    getdisplayedCol = (): string[] => {
        return [...this.displayedColumns, 'action']
    };

    // Handle individual checkbox changes
    onSelectionChange(column: string): void {
        if (this.displayedColumns.includes(column)) {
            this.displayedColumns = this.displayedColumns.filter(c => c !== column);
        } else {
            this.displayedColumns.push(column)
        }
        this.setColsCookie()
    }

    user_name = sessionStorage.getItem('user_name');

    private setColsCookie() {
        this.cookieService.set(`exploitation_cols_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }

    private getColsCookie() {
        const sampleCols = this.cookieService.get(`exploitation_cols_${this.user_name}`); // Get the cookie value

        if (sampleCols) {
            this.displayedColumns = JSON.parse(sampleCols); // Convert the JSON string back to an object
            console.log('Retrieved object:', sampleCols);
        }
    }

    initializeMap(): void {
        this.map = L.map(this.mapId).setView([this.coordonnes.latitude, this.coordonnes.longitude], 13);
    
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© OpenStreetMap contributors'
        }).addTo(this.map);
    
        // Appelle cette fonction pour mettre à jour l'interface utilisateur avec les coordonnées actuelles
        this.updateCoordonnees();
    
        // Écouter l'événement de clic sur la carte
        this.map.on('click', (e: any) => {
            this.coordonnes.latitude = e.latlng.lat;
            this.coordonnes.longitude = e.latlng.lng;
    
            // Mettre à jour les coordonnées du formulaire
            this.updateCoordonnees();
        });
    }
    
    
    updateCoordonnees(): void {
        console.log(this.coordonnes);
        if (this.marker) {
            this.map.removeLayer(this.marker);
        }
        this.marker = L.marker([this.coordonnes.latitude, this.coordonnes.longitude], { icon: this.icon })
            .addTo(this.map)
            .bindPopup(`<b><strong>Point sélectionné : </strong></b><br>Lat: ${this.coordonnes.latitude}<br>Lng: ${this.coordonnes.longitude}`)
            .openPopup();
    
        this.map.setView([this.coordonnes.latitude, this.coordonnes.longitude], this.map.getZoom());
        this.form.patchValue({
            lat: this.coordonnes.latitude,
            lon: this.coordonnes.longitude
        });
        console.log('Coordonnées mises à jour:', this.coordonnes.latitude, this.coordonnes.longitude);
    }
    
}

